import { render, staticRenderFns } from "./searchBlock.vue?vue&type=template&id=48a12846&scoped=true"
import script from "./searchBlock.vue?vue&type=script&lang=js"
export * from "./searchBlock.vue?vue&type=script&lang=js"
import style0 from "./searchBlock.vue?vue&type=style&index=0&id=48a12846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a12846",
  null
  
)

export default component.exports